import React from "react";
import { useNavigate } from "react-router";
import styled from "styled-components";

import { DateTime } from "luxon";
import { getCurrencyConfig } from "./services";
import { RaffleRow, TimeCell, NameWithModel, NameDetails, RaffleType, PrizeCell } from "./RaffleList.styles";
import RaffleTypeModel from "./RaffleTypeModel";

const TournamentRow = styled(RaffleRow)`
  grid-template-columns: 16% minmax(0, 1fr) 18%;
  @media (max-width: 900px) {
    grid-template-columns: minmax(128px, 26%) minmax(0, 1fr);
    & > :last-child { grid-column: 1 / -1; }
  }
  @media (max-width: 480px) {
    grid-template-columns: 1fr;
  }
`;
const TournamentDate = styled.span`
  margin-bottom: 6px;
  font-size: clamp(14px, 1.3vw, 22px);
  font-weight: 400;
  line-height: 1.2;
`;

export default function CardTorneo({ item }) {
  const { id, couponTypeId, premioTipo, amount, couponTypeName: promoName } = item;

  const fechaHora = DateTime.fromISO(item.fechaHora);

  const navigate = useNavigate();

  const goToView = () => {
    navigate(`/torneo-view-rank/${id}?couponTypeId=${couponTypeId}`);
  };

  const currencyConfig = getCurrencyConfig();

  return (
    <TournamentRow type="button" data-testid="tournament-row" onClick={goToView}>
      <TimeCell>
        <TournamentDate>{fechaHora.toFormat("dd/MM")}</TournamentDate>
        <span>{fechaHora.toFormat("hh:mm a")}</span>
      </TimeCell>
      <NameWithModel>
        <RaffleTypeModel kind="trophy" />
        <NameDetails>
        <RaffleType>TORNEO</RaffleType>
        <span>{promoName}</span>
        </NameDetails>
      </NameWithModel>
      <PrizeCell>
        <span>{premioTipo === "soles" || premioTipo === "CASH"
          ? `${currencyConfig.symbol} ${amount}`
          : `${amount} ${item.description || ""}`}</span>
      </PrizeCell>
    </TournamentRow>
  );
}
